import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Batchfile Charges List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchFiles
*/
export const requestBatchfileChargesList = payload => {
	return httpClient({
		method: 'GET',
		url: 'cardtopup/batchfiles',
        params: payload,
		isCancellable: true
	})
}

/** Get Batchfile Charge Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchFiles%7BbatchFileId%7D
*/
export const requestBatchfileChargeDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `cardtopup/batchfiles/${payload.batchfileId}`,
		isCancellable: true
	})
}

/** Get Batchfile Excel Export
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchFiles%7BbatchFileId%7Dexport
*/
export const createBatchfilesExcelURL = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cardtopup/batchfiles/${payload.batchfileId}/export`
	})
}

/** Get Batchfile Excel Export
@docs Sem documentação
*/
export const createBatchfilesPDFReceipt = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `cardtopup/batchfiles/${payload.batchfileId}/sequence/${payload.sequence}/receipt`
	})
}

/** Get Card Group Plafond
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcardtopupbatchfiles%7BcardGroup%7Davailableplafond
*/
export const requestCardGroupPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `cardtopup/batchfiles/${payload}/availableplafond`,
		isCancellable: true
	})
}

/** submit uploaded file with batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcardtopupbatchFilesbatchFilesubmit
*/
export const submitUploadedBatchfile = payload => {
	return httpClient({
		method: 'POST',
		cache: false,
		contentType: false,
		processData: false,
		url: 'cardtopup/batchfiles/batchfile/submit',
		data: payload
	})
}

/** submit manual batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcardtopupbatchFilesbatchFilesubmitmanual
*/
export const submitManualBatchfileCharge = payload => {
	return httpClient({
		method: 'POST',
		url: 'cardtopup/batchfiles/batchfile/submitmanual',
		data: payload
	})
}

/** aprove batchfile charge list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_internetcardtopupbatchFiles%7BbatchFileId%7Dapprove
*/
export const aproveBatchfileCharge = payload => {
	return httpClient({
		method: 'PUT',
		url: `cardtopup/batchfiles/${payload}/approve`,
		operationTypeId: 500001 /* for mocks handling of tokens */
	})
}
